var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCilBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6bceff",
    d: "M116 468A100 100 0 1 0 16 368a100.113 100.113 0 0 0 100 100m0-168a68 68 0 1 1-68 68a68.077 68.077 0 0 1 68-68m180 68a100 100 0 1 0 100-100a100.113 100.113 0 0 0-100 100m100-68a68 68 0 1 1-68 68a68.077 68.077 0 0 1 68-68"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317.912,
    cy: 94.088,
    r: 34.088,
    fill: "#6bceff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6bceff",
    d: "M190.954 266.3L240 314.69V404h32v-92.655a24.154 24.154 0 0 0-7.144-17.084l-51.274-50.588l66.453-66.453l58.165 59.551A24.14 24.14 0 0 0 355.369 244H384v-32h-25.262l-92.487-94.688l-.475.464l-8.4-8.4l-112 112l45.254 45.254Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilBike);
export default __webpack_public_path__ + "static/media/cil--bike.979b48b8e10d65e9ca3590291a2f6915.svg";
export { ForwardRef as ReactComponent };